import { CheckboxField as CssModulesCheckboxField, type CheckboxFieldProps as CssModulesCheckboxFieldProps } from '@sunwebgroup/uds-ui/fields/checkbox-field'
import { styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/fields/checkbox-field' instead.
 */
export type CheckboxFieldProps = CssModulesCheckboxFieldProps

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/checkbox-field' instead.
 */
const CheckboxField = Object.assign(
  styled(CssModulesCheckboxField)<CheckboxFieldProps>``,
  { displayName: 'CheckboxField' },
)

export default CheckboxField
